<template>
  <div class="statement-con" style="padding:0;">
    <div class="customer-list">
      <div class="top-area">
        <div class="select-area">
          <agent-selector class="b-con-filter-area" v-model="belong" ref="customeBelongRef" :agentType="2" :isAll="true" :props="propAttr" :onlyAgent="true" size="small" @change="handleChange()"></agent-selector>
          <el-select size="small" v-model="condition.thread_times_option"  placeholder="请选择进线次数" @change="handleChange()" clearable>
            <el-option  v-for="(item, key) in options.times_option" :key="key" :label="item" :value="key"></el-option>
          </el-select>
          <el-select size="small" v-model="condition.report_times_option"   placeholder="请选择报备次数" @change="handleChange()" clearable>
            <el-option  v-for="(item, key) in options.times_option" :key="key" :label="item" :value="key"></el-option>
          </el-select>
          <el-select size="small" v-model="condition.look_times_option"   placeholder="请选择带看次数" @change="handleChange()" clearable>
            <el-option  v-for="(item, key) in options.times_option" :key="key" :label="item" :value="key"></el-option>
          </el-select>
          <el-select size="small" v-model="condition.repeat_report_times_option"   placeholder="请选择重复报备次数" @change="handleChange()" clearable>
            <el-option  v-for="(item, key) in options.times_option" :key="key" :label="item" :value="key"></el-option>
          </el-select>
          <el-select size="small" v-model="condition.repeat_look_times_option"   placeholder="请选择重复带看次数" @change="handleChange()" clearable>
            <el-option  v-for="(item, key) in options.times_option" :key="key" :label="item" :value="key"></el-option>
          </el-select>
          <el-button size="mini" class="global-btn primary-round"   @click="reset()">重置</el-button>

          <el-button size="mini" icon="el-icon-upload2" class="follow-export-btn"  v-permission="'report.customer.export'"  @click="handleExport">导出数据</el-button>

        </div>
      </div>
      <TableComponent :data="list" :condition="pageData" :isLoading="isLoading" :currentChange="currentChange" class="b-custom-table-only-style day-log-follow-item">
        <el-table-column label="客户姓名" prop="name" fixed>
          <template slot-scope="scope">
            <p @click="toDetail(scope.row)" class="apply-table-cursor" :title="scope.row.name">{{scope.row.name}}</p>
          </template>
        </el-table-column>
        <el-table-column label="来源方式" prop="source_name"></el-table-column>
        <el-table-column label="创客时间" prop="created_at" width="140"></el-table-column>
        <el-table-column label="" width="150">
          <template  slot="header">
            <span>进线次数</span>
            <el-popover placement="top-start" title="" trigger="hover">
              <div class="threads-tips">
                <p>记录客户所有联系号码在业务平台的报名次数</p>
              </div>
              <i class="iconfont" slot="reference">&#xe611;</i>
            </el-popover> 
          </template>     
          <template slot-scope="scope">
            <el-popover placement="top-start" title="" trigger="hover" v-if="scope.row.thread_times > 0">
              <div class="threads-tips">
                <p v-for="(item,index) in scope.row.thread_list" :key="index">第{{index+1}}次进线时间：{{ item }}</p>
              </div>
              <p @click="toDetail(scope.row,{journeyType: 15})" class="apply-table-cursor"  slot="reference">{{scope.row.thread_times}}次</p>
            </el-popover>
            <p v-else>0</p>

          </template>   
        </el-table-column>
        <el-table-column width="150">
          <template  slot="header">
            <span>首次归属人</span>
            <el-popover placement="top-start" title="" trigger="hover">
              <div class="threads-tips">
                <p>展示客户首次归属人姓名</p>
              </div>
              <i class="iconfont" slot="reference">&#xe611;</i>
            </el-popover> 
          </template>     
          <template slot-scope="scope">
            <p :title="scope.row.first_admin_name || '--'">{{ scope.row.first_admin_name || '--' }}</p>
          </template>
        </el-table-column>
        <el-table-column width="150">
          <template  slot="header">
            <span>当前归属人</span>
            <el-popover placement="top-start" title="" trigger="hover">
              <div class="threads-tips">
                <p>展示客户当前归属人姓名</p>
              </div>
              <i class="iconfont" slot="reference">&#xe611;</i>
            </el-popover> 
          </template>    
          <template slot-scope="scope">
            <p :title="scope.row.admin_name || '--'">{{ scope.row.admin_name || '--' }}</p>
          </template>
        </el-table-column>
        <el-table-column label="客户当前状态" prop="latest_stage_name"  width="120">
          <template slot-scope="scope">
            <p :title="scope.row.latest_stage_name || '--'">{{ scope.row.latest_stage_name || '--' }}</p>
          </template>
        </el-table-column>
        <el-table-column label="" width="120">    
          <template  slot="header">
            <span>全部跟进次数</span>
            <el-popover placement="top-start" title="" trigger="hover">
              <div class="threads-tips">
                <p>客户从创建开始截止到目前为止的跟进次数。跟进指产生了普通跟进记录的行为。</p>
              </div>
              <i class="iconfont" slot="reference">&#xe611;</i>
            </el-popover> 
          </template>     
          <template slot-scope="scope">
            <p @click="toFollow(scope.row)" class="apply-table-cursor" v-if="scope.row.follow_times > 0">{{scope.row.follow_times}}次</p>
            <p v-else>{{scope.row.follow_times || '0'}}</p>
          </template>   
        </el-table-column>
        <el-table-column label="" width="120">  
          <template  slot="header">
            <span>全部报备次数</span>
            <el-popover placement="top-start" title="" trigger="hover">
              <div class="threads-tips">
                <p>客户从创建开始的提交并审核通过的报备次数。</p>
              </div>
              <i class="iconfont" slot="reference">&#xe611;</i>
            </el-popover> 
          </template>    
          <template slot-scope="scope">
            <p @click="toCommercial(scope.row,22)" class="apply-table-cursor" v-if="scope.row.report_times > 0">{{scope.row.report_times}}次</p>
            <p v-else>{{scope.row.report_times || '0'}}</p>
          </template>   
        </el-table-column>
        <el-table-column label="" width="120">   
          <template  slot="header">
            <span>全部带看次数</span>
            <el-popover placement="top-start" title="" trigger="hover">
              <div class="threads-tips">
                <p>客户从创建开始的提交并审核通过的带看次数。</p>
              </div>
              <i class="iconfont" slot="reference">&#xe611;</i>
            </el-popover> 
          </template>     
          <template slot-scope="scope">
            <p @click="toCommercial(scope.row,25)" class="apply-table-cursor" v-if="scope.row.look_times > 0">{{scope.row.look_times}}次</p>
            <p v-else>{{scope.row.look_times || '0'}}</p>
          </template>   
        </el-table-column>
        <el-table-column label="" width="120">
          <template  slot="header">
            <span>全部成交次数</span>
            <el-popover placement="top-start" title="" trigger="hover">
              <div class="threads-tips">
                <p>客户从创建开始的提交并审核通过的认购次数</p>
              </div>
              <i class="iconfont" slot="reference">&#xe611;</i>
            </el-popover> 
          </template>       
          <template slot-scope="scope">
            <p @click="toCommercial(scope.row)" class="apply-table-cursor" v-if="scope.row.deal_times > 0">{{scope.row.deal_times}}次</p>
            <p v-else>{{scope.row.deal_times || '0'}}</p>
          </template>   
        </el-table-column>
        <el-table-column label="" width="150">
          <template  slot="header">
            <span>重复进线后 报备次数</span>
            <el-popover placement="top-start" title="" trigger="hover">
              <div class="threads-tips">
                <p>客户从第二次进线后截止到当前的提交并审核通过的报备次数</p>
              </div>
              <i class="iconfont" slot="reference">&#xe611;</i>
            </el-popover> 
          </template>    
          <template slot-scope="scope">
            <p :title="scope.row.repeat_report_times" v-if="scope.row.repeat_report_times >0">{{scope.row.repeat_report_times}}次</p>
            <p v-else>{{scope.row.repeat_report_times || 0}}</p>
          </template>   
        </el-table-column>
        <el-table-column  width="150">
          <template  slot="header">
            <span>重复进线后 带看次数</span>
            <el-popover placement="top-start" title="" trigger="hover">
              <div class="threads-tips">
                <p>客户从第二次进线后截止到当前的提交并审核通过的带看次数</p>
              </div>
              <i class="iconfont" slot="reference">&#xe611;</i>
            </el-popover> 
          </template>    
          <template slot-scope="scope">
            <p :title="scope.row.repeat_look_times" v-if="scope.row.repeat_look_times >0">{{scope.row.repeat_look_times}}次</p>
            <p v-else>{{scope.row.repeat_look_times || 0}}</p>
          </template>   
        </el-table-column>
    </TableComponent>
    </div>
  </div>
</template>
<script>
import TableComponent from '@/components/table/index';
import AgentSelector from '@/components/select/AgentSelector';
import {getDetailPermission} from '@/api/custome';
import {getCustomerDetailList,exportCustomerList} from '@/api/sale';
import { mapState } from 'vuex';
export default{
  name: 'CustomerData',
  props: {
    getParams: Function
  },
  components: {
    AgentSelector,
    TableComponent
  },
  computed: {
    ...mapState({
      emitName: state => state.const.emitName
    })
  },
  data () {
    return {
      belong:{admin_id: -1},
      select_type: 0,
      dateType: 1,
      isLoading: false,
      pageData:{
        page: 1,
        per_page: 20,
        total: 0,
      },
      condition: {
        thread_times_option:'',
        report_times_option:'',
        look_times_option:'',
        repeat_report_times_option:'',
        repeat_look_times_option:''
      },
      list: [],
      options:{},
      hasBusinessPermission:false,
      hasFollowPermission:false,
      propAttr: {
        checkStrictly: false,
        emitPath: false,
        expandTrigger: 'hover',
        value: 'id', 
        label: 'name'
      }
    }
  },
  async mounted () {
    this.hasBusinessPermission = await this.$store.dispatch('user/hasPermission', 'customer.business');
    this.hasFollowPermission = await this.$store.dispatch('user/hasPermission', 'customer.business.detail.follow');

  },
  async created () {
    const keys = ['times_option'];
    this.options = await this.$store.dispatch('initConfig', keys);
  },
  methods: {
    handleChange () {
      this.pageData.page = 1;
      this.initCustomerDetail();
    },
    async initCustomerDetail () {
      const params = this.getParams();
      var paramter={
        ...params,
        ...this.condition,
        ...this.pageData
      }
      if (this.belong && this.belong.admin_id != -1) {
        paramter = {...paramter, ...this.belong};
      }
      try {
        const res = await getCustomerDetailList(paramter);
        this.list = res.data
        this.$set(this.pageData, 'total', res.total);

      } catch (error) {
        this.$message.error(error.msg || '操作错误，请重试');
      }
    },
    search () {
      this.initCustomerDetail();
    },
    reset(){
      this.condition= {
        thread_times_option:'',
        report_times_option:'',
        look_times_option:'',
        repeat_report_times_option:'',
        repeat_look_times_option:''
      }
      this.belong = {
        admin_id: -1
      }
      this.pageData.page = 1;
      this.search();
    },
    currentChange (page) {
      this.pageData.page = page;
      this.search();
    },
    async handleExport () {
      const params = this.getParams();
      var paramter={
        ...params,
        ...this.condition,
      }
      if (this.belong && this.belong.admin_id != -1) {
        paramter = {...paramter, ...this.belong};
      }
      try {
        await exportCustomerList(paramter);
        this.$EventBus.$emit(`importAnimate`, 1);
      } catch (error) {
        this.$message.error(error.msg || '操作失败，请重试');
      }
    },
    toCommercial (row, params) {
      if(params){
        if(!this.hasBusinessPermission){
        this.$message.error('你没有查看商机明细的权限');
        }else{
          this.$router.push(`/work-flow/commercial/list?customer_id=${row.id}&business_stage=${params}`);
        }
      }else{
        if(!this.hasBusinessPermission){
          this.$message.error('你没有查看订单明细的权限');
        }else{
          this.$router.push(`/work-flow/commercial/list?customer_id=${row.id}`);
        }
      }
     
     
    },
    toFollow(row){
      if(!this.hasFollowPermission){
        this.$message.error('你没有查看跟进明细的权限');
      }else{
        this.$router.push(`/work-flow/follow/list?id=${row.id}`);
      }
    },
    async toDetail (row,params) {
      try {
        const res = await getDetailPermission(row.id);
        this.$EventBus.$emit(this.emitName, {category: 'customerDetail', params: {
          customerId: row.id,
          ...params
        }}); 
      } catch (error) {
        this.$message.error(error.msg || '操作失败，请重试');
      }
    },
  }
}
</script>
<style lang="less">
@import url('~@/assets/style/base/table.less');
</style>
<style lang="less">
.cus-th-compelete{
  border-left: 1px solid #dcdcdc !important;
}
.wait-report-list{
  .task-table{
    padding: 0 20px;
  }
}
</style>